import { Injectable } from '@angular/core';
import { HttpClient } from './http-client.service';
import * as model from '../../models';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class MerchantEmailConfigApi {
	private merchantEmailConfigUrl = '/api/merchants/v1/merchantEmailConfigurations';

	constructor(private httpClient: HttpClient) {}

	public updateMerchantEmailConfig(emailConfig: model.MerchantEmailConfig): Observable<model.MerchantEmailConfig> {
		let body = JSON.stringify(emailConfig);
		return this.httpClient.put(emailConfig._links.self.href, body)
			.map(response => response.json());
	}

	public getMerchantEmailConfigs(merchantId: string): Observable<model.MerchantEmailConfig[]> {
		return this.httpClient.get(this.merchantEmailConfigUrl + '/' +  merchantId)
			.map(response => response.json()._embedded.merchantEmailConfigurations);
	}
}



// WEBPACK FOOTER //
// ./src/app/services/webservice/merchant-email-config-api.service.ts